import { message } from 'antd'
import serviceInterface from '../../services/service.interface'
import ActionType from '../action.types'

/*
Actions to be dispatched for regimen
- Inprogress
    action to dispatch incase of operation in progress
- set regimens
    action to dispatch incase to push assigned regs
*/

export function operationInProgress(isLoading) {
  return {
    type: ActionType.REG_INPROGRESS,
    isLoading,
  }
}

export function assignRegimens({ regimens }) {
  return {
    type: ActionType.REG_SET_ASSIGNED,
    regimens,
  }
}

export function setRegimens({ regimens, filters }) {
  return {
    type: ActionType.REG_SET_REGS,
    regimens,
    filters,
  }
}

export function getAutoAssignedRegs(patient) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .RegimenServide()
        .getAutoAssignedRegimens(patient)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else dispatch(assignRegimens(data))
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}

export function getRegimens(filter) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.RegimenServide().getRegimens(filter)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else dispatch(setRegimens(data))
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
    }
  }
}
